const locale = {
	// #region Kpis Goals section
	TAB_KPIS_GOALS: 'KPIs Goals',
	TAB_KPIS_GOALS_VALUES: 'KPIs Goals Values',

	DIALOG_KPIS_GOALS_DIALOG_ADD_TITLE: 'New KPI Goal',
	DIALOG_KPIS_GOALS_DIALOG_EDIT_TITLE: 'Edit KPI Goal',

	BUTTON_KPI_GOAL_NEW: 'New Goal',

	DETAILS_KPIS_GOALS_FIELD_KPI: 'KPI',
	DETAILS_KPIS_GOALS_FIELD_DATE_FROM: 'Date from',
	DETAILS_KPIS_GOALS_FIELD_DATE_TO: 'Date to',
	DETAILS_KPIS_GOALS_FIELD_STATUS: 'KPI Goal Status',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE: 'Clause',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE_GREATER: 'Greater',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE_SMALLER: 'Smaller',
	DETAILS_KPIS_GOALS_FIELD_CURRENT_VALUE: 'Current value',
	DETAILS_KPIS_GOALS_FIELD_TARGET_VALUE: 'Target value',
	DETAILS_KPIS_GOALS_FIELD_RESIDUAL_VALUE: 'Residual value',
	DETAILS_KPIS_GOALS_FIELD_PROGRESS: 'Progress',
	DETAILS_KPIS_GOALS_FIELD_AGGREGATION_TITLE: 'Linked element',

	// DETAILS_KPIS_GOALS_FIELD_MODULE_APPLYTOALL: 'Apply to all "{{type}}"'
	DETAILS_KPIS_GOALS_FIELD_MODULE_APPLYTOALL: 'Apply to all'
	// #endregion
};

export default locale;
